module.exports = __webpack_public_path__ + "img/DFW_Axe.0ad9683c.png";